import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { aboutimg, destination } from "../Constant/Index";

const AboutUs = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="About Us" />
			<section className="meet-our-expert about-expert">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="solve-detail-img  radius-20 p-4">
								<div className="row align-items-center">
									<div className="col-lg-6 position-relative">
										<figure>
											<img src={aboutimg} className="img-fluid p-4" alt="" />
										</figure>
									</div>
									<div className="col-lg-6">
										<div className="solved-heading pe-4">
											<h5 className="linear-bg-heading widht-wrapper mb-3 primary-regular-font">
												MEET OUR EXPERT
											</h5>
											<h3 className="main-heading-font dark-color level-3 wow animate__ animate__zoomIn animated">
												Dr. Preston White Akough-Weir, MD MBA
											</h3>
											<p className="primary-regular-font extra-color-5 level-7">
												Our health library is packed with the latest research
												and advice to keep you in the know about your
												well-being. Research and advice to keep you in the know
												about your well-being.
												<br />
												<br />
												In the digital age, your health deserves the smartest
												care. Lane AW Health is the premier online healthcare
												platform that brings comprehensive medical services
												right to your fingertips.
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="solved-sec about-solved pt-5 pb-4 ">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="row">
								<div className="col-lg-12">
									<h2 className="main-heading-font dark-color level-2 text-center wow animate__animated animate__zoomIn">
										Solve real problems
									</h2>
									<div className="text-center pb-4">
										<p className="primary-regular-font extra-color-5 level-7">
											In the digital age, your health deserves the smartest
											care. Lane AW Health is the premier online healthcare
											platform that brings comprehensive medical services right
											to your fingertips.
										</p>
									</div>
								</div>
							</div>
							<div className="solve-detail-img  radius-20 p-5">
								<div className="row align-items-center">
									<div className="col-lg-6 pe-5">
										<div className="solved-heading">
											<h5 className="extra-color-7 primary-medium-font level-6">
												"Access a network of certified doctors and specialists
												for consultations, second opinions, and ongoing care all
												from the comfort of your home."
											</h5>
											<h6 className="extra-color-7 primary-regular-font mb-3 mt-2 level-7">
												Thomas Andrew, CEO and founder at MMF
											</h6>
											<a
												href="signin"
												className="btn log-in level-7 primary-regular-font text-decoration-none"
											>
												<span className="bg-wrapper">Read more</span>
											</a>
										</div>
									</div>
									<div className="col-lg-6">
										<figure>
											<img src={destination} className="img-fluid" alt="" />
										</figure>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="our-mission-vision mb-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="row">
								<div className="col-lg-6">
									<div className="our-content extra-bg-8 p-5 radius-20">
										<h3 className="main-heading-font dark-color ">
											Our Mission
										</h3>
										<p className="extra-color-13 mt-3">
											Lorem ipsum dolor sit amet consectetur. Tortor cras massa
											nam adipiscing lacus accumsan elit morbi lacus. Pulvinar
											ullamcorper fermentum massa pellentesque. adipiscing lacus
											accumsan elit morbi lacus.
										</p>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="our-content extra-bg-8 p-5 radius-20">
										<h3 className="main-heading-font dark-color ">
											Our Vision
										</h3>
										<p className="extra-color-13 mt-3">
											Lorem ipsum dolor sit amet consectetur. Tortor cras massa
											nam adipiscing lacus accumsan elit morbi lacus. Pulvinar
											ullamcorper fermentum massa pellentesque. adipiscing lacus
											accumsan elit morbi lacus.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default AboutUs;
